import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import axios from "axios"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { loadStripe } from "@stripe/stripe-js"
import { API_URL, STRIPE_KEY } from "../../data"
// Components
import { Elements } from "@stripe/react-stripe-js"
import CheckoutForm from "../CheckoutForm/CheckoutForm"
// Styles
import { Container, Title } from "./Payment.styles"
import { fontFamily, fontSizeS } from "../../GlobalStyle"
import { useTheme } from "styled-components"

const stripePromise = loadStripe(STRIPE_KEY)

const Payment = ({ display, amount }) => {
   const theme = useTheme()
   const { t } = useTranslation()
   const language = useSelector((state) => state.environment.language)
   const [clientSecret, setClientSecret] = useState("")

   const appearance = {
      theme: theme.name === "dark" ? "night" : "stripe",
      variables: {
         colorPrimary: theme.primary,
         colorBackground: theme.body,
         colorText: theme.text,
         colorDanger: theme.secondary,
         fontFamily: `${fontFamily}, sans-serif`,
         fontSizeBase: fontSizeS,
      },
   }

   useEffect(() => {
      if (!display || !amount) return

      const getClientSecret = async () => {
         try {
            const res = await axios.post(`${API_URL}payment`, {
               amount: amount * 100,
            })
            setClientSecret(res.data.clientSecret)
         } catch (err) {
            console.error(
               "Erreur création clientSecret:",
               err.response?.data || err.message
            )
         }
      }
      getClientSecret()
   }, [display, amount])

   return (
      <Container display={display ? "flex" : "none"}>
         <Title>{t("payment.title.t1")}</Title>
         {clientSecret && stripePromise && (
            <Elements
               stripe={stripePromise}
               options={{ clientSecret, appearance, locale: language }}
            >
               <CheckoutForm />
            </Elements>
         )}
      </Container>
   )
}

Payment.propTypes = {
   display: PropTypes.bool,
   amount: PropTypes.number,
}

export default Payment
